export const filterTeamMembers = (teamMembers = [], currentUser = {}) =>
  teamMembers.filter(
    (member) =>
      member.email !== currentUser.email &&
      member.first_name.length + member.last_name.length !== 0,
  );
